// COPYRIGHT SMARTTRACK

/**
 * Requires
 */

const Constants = require('../../../Constants');
const { selectCheckmark } = require('../modules/input');
const {
	handlePerformanceConsentUpdate,
	handleAnalyticsConsentUpdate,
	handleTargetingConsentUpdate
} = require('../modules/cookies');


/**
 * Handlers
 */

const handleConsentStateChange = (cookie, element) => {

	// Update consent cookie
	const expires = (new Date(Date.now() + Constants.CONSENT_COOKIE_EXPIRATION)).toUTCString();
	document.cookie = `${Constants.CONSENT_ACTION_TAKEN_COOKIE}=true; expires=${expires}; path=/`;
	if ($(element).hasClass('active')) {
		document.cookie = `${cookie}=true; expires=${expires}; path=/`;
	} else {
		document.cookie = `${cookie}=false; expires=${expires}; path=/`;
	}

	// Hide cookie bar if present
	if ($('#cookie-consent-bar').length) {
		const value = `-${$('#cookie-consent-bar').outerHeight()}px`;
		$('#cookie-consent-bar').animate({ bottom: value }, 300, function () {
			$(this).hide();
		});
	}
};


/**
 * Action Handlers
 */

const createActionHandlers = async () => {

	// Handle select performance cookies option
	$(document).on('click', '#cookie-settings-check-custom-2', function () {

		// Toggle selected state
		selectCheckmark('cookie-settings-check-custom-2', 'cookie-settings-check-2');

		// Change consent state
		handleConsentStateChange(Constants.CONSENT_PERFORMANCE_ENABLED_COOKIE, this);

		// Handle consent state change
		handlePerformanceConsentUpdate($(this).hasClass('active'));
	});

	// Handle select performance cookies option
	$(document).on('click', '#cookie-settings-check-custom-3', function () {

		// Toggle selected state
		selectCheckmark('cookie-settings-check-custom-3', 'cookie-settings-check-3');

		// Change consent state
		handleConsentStateChange(Constants.CONSENT_ANALYTICS_ENABLED_COOKIE, this);

		// Handle consent state change
		handleAnalyticsConsentUpdate($(this).hasClass('active'));
	});

	// Handle select performance cookies option
	$(document).on('click', '#cookie-settings-check-custom-4', function () {

		// Toggle selected state
		selectCheckmark('cookie-settings-check-custom-4', 'cookie-settings-check-4');

		// Change consent state
		handleConsentStateChange(Constants.CONSENT_TARGETING_ENABLED_COOKIE, this);

		// Handle consent state change
		handleTargetingConsentUpdate($(this).hasClass('active'));
	});
};


/**
 * State Handlers
 */

exports.handlerDidLoad = async () => {

	// Create action handlers
	createActionHandlers();
};

exports.handlerDidAppear = async () => { };
